import { render, staticRenderFns } from "./theme-icons.vue?vue&type=template&id=11d8fb54&scoped=true&"
import script from "./theme-icons.vue?vue&type=script&lang=js&"
export * from "./theme-icons.vue?vue&type=script&lang=js&"
import style0 from "./theme-icons.vue?vue&type=style&index=0&id=11d8fb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d8fb54",
  null
  
)

export default component.exports